import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DurationPipe } from './pipes/duration.pipe'; // Example pipe
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { PaginationModule } from './pipes/pagination/pagination.module';
import { TooltipDirective } from './pipes/bs-tooltip.pipe'; // Example directive
import { InputRequiredDirective } from './pipes/input-required.pipe';
import { MediaSelectModule } from './pipes/media-select/media-select.module';
import { FilesizePipe } from './pipes/filesize.pipe';
import { FiletypePipe } from './pipes/filetype.pipe';
import { MoneyPipe } from './pipes/money.pipe';

@NgModule({
  declarations: [
    DurationPipe,
    FilesizePipe,
    FiletypePipe,
    MoneyPipe,
    InputRequiredDirective,
    TooltipDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    DurationPipe,
    FilesizePipe,
    FiletypePipe,
    MoneyPipe,
    TooltipDirective,
    TranslatePipe,
    PaginationModule,
    InputRequiredDirective,
  ],
})
export class SharedModule { }
